import { FeatureAccessPermissions, Role } from "@/context/data.types";

// This function retrieves role-based permissions for a specific feature
// from local storage and returns an object mapping action keys to boolean values
export function fetchRoleBasedAccess(roles: Role[]): FeatureAccessPermissions {
    const result: FeatureAccessPermissions = {};
   roles?.forEach((role) => {
    role?.features?.forEach((feature) => {
      const featureId = (feature?.featureid ?? "").toString();
      if (!featureId) return;
      const entry = result[featureId] ?? (result[featureId] = { accessMap: {} });
      feature?.access?.forEach(({ accessid, accessdescription }) => {
        if (typeof accessdescription !== "string" || !accessdescription) return;
        entry.accessMap[accessdescription] = accessid;
      });
    });
  });

  return result;
}

// export function getFeatureAccessPermissions(featureId: number): { [description: string]: string } {
//     const stored = localStorage.getItem("roleBasedAccessPermissions")
//       ? JSON.parse(localStorage.getItem("roleBasedAccessPermissions") as string)
//       : {};
  
//     const parsed: FeatureAccessPermissions = JSON.parse(stored);
//     return parsed[featureId]?.accessMap;
// }
export function getStoredRoleBasedAccessPermissions(): FeatureAccessPermissions {
  if (typeof window === "undefined") return {};

  const stored = localStorage.getItem("roleBasedAccessPermissions");
  if (!stored) return {};

  try {
    return JSON.parse(stored) as FeatureAccessPermissions;
  } catch {
    return {};
  }
}

export function hasFeaturePermission(
  permissions: FeatureAccessPermissions,
  featureId: number | string,
  accessKeys: readonly string[]
): boolean {
  if (accessKeys.length === 0) return false;

  const accessMap = permissions[featureId.toString()]?.accessMap;
  if (!accessMap) return false;

  return accessKeys.some((accessKey) => Boolean(accessMap[accessKey]));
}
export function getFeatureAccessPermissions(featureId: number | string): { [description: string]: boolean } {
  const parsed = getStoredRoleBasedAccessPermissions();
  const accessMap = parsed[featureId.toString()]?.accessMap || {};
  const booleanMap: { [description: string]: boolean } = {};

  Object.keys(accessMap).forEach((description) => {
    booleanMap[description] = true;
  });

  return booleanMap;
}
